import React, { useMemo } from 'react';
import { NumberFormatCustom } from 'shared';
import { enumHelper, TOBACCO_RING_POSITION, isSkeletonLoading } from 'shared';
import { FILTER_TYPE } from 'shared/ViewTable/AdvancedFilters';

export function useTobaccoProductsBuildTable(inputs, t) {
  const tobaccoRingPositionElements = useMemo(() => {
    return enumHelper.enumToFilter(TOBACCO_RING_POSITION, t, 'ringPositions');
  }, [t]);

  const headCells = useMemo(() => {
    return [
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: t('properties.name'),
        ellipsis: true,
        style: { minWidth: '25rem', width: '36% ' }
      },
      {
        id: 'cigarAmount',
        numeric: true,
        disablePadding: false,
        label: t('properties.cigarAmount')
      },
      {
        id: 'litterAmount',
        numeric: true,
        disablePadding: false,
        label: t('properties.litterAmount')
      },
      {
        id: 'tobaccoRingPosition',
        numeric: false,
        disablePadding: false,
        label: t('properties.tobaccoRingPosition'),
        filterType: FILTER_TYPE.COMBO,
        filterValues: tobaccoRingPositionElements
      },
      {
        id: 'masterCaseCaseAmount',
        numeric: true,
        disablePadding: false,
        label: t('properties.masterCaseCaseAmount')
      }
    ];
  }, [t, tobaccoRingPositionElements]);

  const rows = useMemo(() => {
    if (!inputs) {
      return [];
    }
    return inputs.items.map(product => ({
      name: product.name,
      cigarAmount: product.cigarAmount,
      litterAmount: product.litterAmount,
      length: isSkeletonLoading(product.length)
        ? product.length
        : product.length && <NumberFormatCustom displayType={'text'} value={product.length} />,
      width: isSkeletonLoading(product.width)
        ? product.width
        : product.width && <NumberFormatCustom displayType={'text'} value={product.width} />,
      height: isSkeletonLoading(product.height)
        ? product.height
        : product.height && <NumberFormatCustom displayType={'text'} value={product.height} />,
      tobaccoRingPosition: isSkeletonLoading(product.tobaccoRingPosition)
        ? product.tobaccoRingPosition
        : tobaccoRingPositionElements &&
          tobaccoRingPositionElements.filter(r => r.value === product.tobaccoRingPosition.toString())[0]?.name,
      masterCaseCaseAmount: product.masterCaseCaseAmount,
      canBeDeleted: !product.hasRelatedProducts && !product.hasRequests,
      id: product.id
    }));
  }, [inputs, tobaccoRingPositionElements]);

  return { headCells, rows };
}
